"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _text = _interopRequireDefault(require("@ux/text"));
/**
 * Tray title component.
 *
 * Tray titles are for rendering a title inside of the open tray menu.
 *
 * TrayTitle
 * @param {React.ComponentProps} props component props
 * @param {React.ReactChild} props.children rendered children
 * @returns {React.ReactElement} react element
 * @api public
 */
function TrayTitle(props) {
  return /*#__PURE__*/_react.default.createElement(_text.default.h2, {
    as: "title",
    size: 1,
    text: props.children,
    className: "tray-title"
  });
}

/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayTitle.propTypes = {
  children: _propTypes.default.node
};
var _default = exports.default = TrayTitle;